import { useEffect, useState } from "react";
import { api, Audience } from "../api";
import { Paper, Stack, Button, Typography, TextField } from "@mui/material";
import { useAuth } from "../auth/AuthContext";

export default function AudiencesPage() {
  const { isSuperAdmin } = useAuth();
  const [rows, setRows] = useState<Audience[]>([]);
  const [editing, setEditing] = useState<Audience | null>(null);

  async function load() {
    const r = await api.get<Audience[]>("/audiences");
    setRows(r.data);
  }
  useEffect(() => { load().catch(console.error) }, []);

  return (
    <Stack spacing={2}>
      <Paper sx={{ p:2 }}>
        <Stack direction="row" gap={2}>
          {isSuperAdmin && (
            <Button variant="contained" onClick={() => setEditing({ id:"", name:"", description:"", criteria:{} })}>New Audience</Button>
          )}
          <Button variant="outlined" onClick={() => load().catch(console.error)}>Refresh</Button>
        </Stack>
      </Paper>

      <Stack direction={{ xs:"column", md:"row" }} gap={2}>
        <Paper sx={{ p:2, flex:1 }}>
          <Typography variant="h6" gutterBottom>Audiences</Typography>
          <Stack gap={1}>
            {rows.map(a => (
              <Paper key={a.id} sx={{ p:1.5, cursor: isSuperAdmin ? "pointer" : "default" }}
                     onClick={isSuperAdmin ? () => setEditing(a) : undefined}>
                <Typography><strong>{a.name}</strong></Typography>
                <Typography color="text.secondary">{a.description || ""}</Typography>
              </Paper>
            ))}
            {!rows.length && <Typography color="text.secondary">No audiences.</Typography>}
          </Stack>
        </Paper>

        <Paper sx={{ p:2, flex:2 }}>
          <Typography variant="h6" gutterBottom>Editor</Typography>
          {!isSuperAdmin ? (
            <Typography color="text.secondary">Audiences are global reference data; super-admin required to edit.</Typography>
          ) : !editing ? (
            <Typography color="text.secondary">Select or create an Audience.</Typography>
          ) : (
            <Stack gap={2}>
              <TextField label="Name" value={editing.name} onChange={e=>setEditing({...editing, name: e.target.value})}/>
              <TextField label="Description" value={editing.description||""} onChange={e=>setEditing({...editing, description: e.target.value})}/>
              <TextField
                label="Criteria (JSON)" multiline minRows={6}
                value={JSON.stringify(editing.criteria ?? {}, null, 2)}
                onChange={e=>{
                  try { setEditing({...editing, criteria: JSON.parse(e.target.value || "{}")}); }
                  catch { /* keep old until valid */ }
                }}
              />
              <Stack direction="row" gap={2}>
                <Button variant="contained" onClick={async ()=>{
                  await api.post("/audiences", { id: editing.id || null, name: editing.name, description: editing.description, criteria: editing.criteria });
                  await load(); alert("Saved");
                }}>Save</Button>
              </Stack>
            </Stack>
          )}
        </Paper>
      </Stack>
    </Stack>
  );
}
